// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3tjVL","buttons":"RemoveExpirationActionButtons_buttons__NUEje"};